export default function getShareOptionsData() {
  return [
    {
      type: 'linkedin',
      label: 'Share on LinkedIn',
      icon: 'icon-linkedin',
      href: 'https://www.linkedin.com/shareArticle?url={url}&amp;title={title}',
    },
    {
      type: 'twitter',
      label: 'Share on Twitter',
      icon: 'icon-twitter',
      href: 'https://twitter.com/intent/tweet?text={title}&url={url}',
    },
    {
      type: 'email',
      label: 'Share on email',
      icon: 'icon-email',
      href: 'mailto:?to=&body={url},&subject={title}',
    },
    {
      type: 'copylink',
      label: 'Copy link',
      icon: 'icon-paperclip',
    },
  ];
}
